import { Injectable, computed, signal } from '@angular/core';
import { LanguageCode, LanguageOption, SiteTranslations } from './translation.types';
import { TRANSLATIONS } from './translations';

const STORAGE_KEY = 'pupil-lab-lang';

@Injectable({ providedIn: 'root' })
export class TranslationService {
  readonly languages: LanguageOption[] = [
    { code: 'en', label: 'English' },
    { code: 'vi', label: 'Tiếng Việt' },
  ];

  readonly currentLang = signal<LanguageCode>(this.getInitialLang());
  readonly content = computed<SiteTranslations>(() => TRANSLATIONS[this.currentLang()]);

  constructor() {
    this.applyDocumentLang(this.currentLang());
  }

  setLanguage(code: LanguageCode): void {
    this.currentLang.set(code);
    localStorage.setItem(STORAGE_KEY, code);
    this.applyDocumentLang(code);
  }

  getLanguageLabel(code: LanguageCode): string {
    return this.languages.find((lang) => lang.code === code)?.label ?? code;
  }

  private getInitialLang(): LanguageCode {
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored === 'vi' ? 'vi' : 'en';
  }

  private applyDocumentLang(code: LanguageCode): void {
    document.documentElement.lang = code;
    document.title = TRANSLATIONS[code].meta.title;
  }
}
